import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=6647916f&scoped=true&"
import script from "./TopBanner.vue?vue&type=script&lang=js&"
export * from "./TopBanner.vue?vue&type=script&lang=js&"
import style0 from "./TopBanner.vue?vue&type=style&index=0&id=6647916f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647916f",
  null
  
)

export default component.exports